import { createContext } from 'react'
import 'src/BlockchainAdapter/BlockchainAdapter.types'

const AdapterContext = createContext<{ [key: string]: any }>({})

export default AdapterContext
